
import { computed, defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router'
import SimpleCard from '@/components/block/SimpleCard.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import { MagazineSpecialRecommendContent } from '@/types/MagazineRecommend'

export default defineComponent({
  name: 'HomeRecommendSeries',

  components: {
    SimpleCard,
    HeadingLv2,
    Button
  },

  props: {
    contents: {
      type: Array as PropType<MagazineSpecialRecommendContent[]>,
      default: () => []
    }
  },

  setup(props) {
    const router = useRouter()
    const moveToSeriesIndex = () => {
      router.push(`/magazines/series`)
    }
    return {
      displayContents: computed(() => props.contents.slice(0, 4)),
      moveToSeriesIndex
    }
  }
})
